import YFormWalletProcessing from './WalletProcessing.vue';

export { YFormWalletProcessing };
export default YFormWalletProcessing;
